import DA56_En_Jul13 from '../DA56_En_Jul13.json';
import DASUP from '../dasupplemental.json';
import { Store } from '../models/Store';
import { Folder } from '../models/Folder';
import { FolderItem } from '../models/FolderItem';
import { KnownItem, Supplemental } from '../models/Supplemental';
import ArrayHelper from '../utils/ArrayHelper';
import TextHelper from '../utils/TextHelper';
// import StyleHelper from '../utils/StyleHelper';

export default class DAService {
  private static baseData: Store = DA56_En_Jul13 as unknown as Store;

  private static supData: Supplemental = DASUP as unknown as Supplemental;

  private static data: Store = this.mapSupplemental(this.baseData);

  private static searchItems: any[] | null = null;

  private static selectedFolder: Folder | null = null;

  private static selectedFolderItem: FolderItem | null = null;

  private static selectedFolderItem2: FolderItem | null = null;

  private static mapObject(objData: any) {
    let modProperty: any = {};
    const supplementalAddon: KnownItem | undefined = this.supData.knownItems.find((supl) => String(supl?.itemId) === String(objData?.itemId));

    Object.keys(objData).forEach((key) => {
      if (typeof objData[key] === 'object' && Array.isArray(objData[key])) {
        modProperty[key] = objData[key].map((val: any, i: any) => {
          // Set defaults for guidance
          if (key === 'inlineGuidance') {
            return { ...val, icon: this.supData.defaultIcons.guidance };
          }

          if (typeof objData[key][i] === 'object' && !Array.isArray(objData[key][i])) {
            return this.mapObject(objData[key][i]);
          }

          return val;
        });
      } else {
        modProperty[key] = objData[key];
      }
    });

    // Determine what type
    const indexes: any = this.getPath(this.baseData, objData.itemId || '0');
    const lastIndex = (indexes?.length || 0) - 1;
    let defaultIconColor: 'topic' | 'processGoal' | 'decision' | 'option' = '' as any;

    // Option
    if (lastIndex > 0 && indexes[lastIndex - 1]?.hasOptions) {
      defaultIconColor = 'option';
      // Decision
    } else if (lastIndex > 0 && indexes[lastIndex - 1]?.hasDecisionPoints) {
      defaultIconColor = 'decision';
      // Goal
    } else if (lastIndex > 0 && indexes[lastIndex - 1]?.hasFolderItems && objData?.decisionPoints) {
      defaultIconColor = 'processGoal';
      // Topic
    } else if (lastIndex > 0 && indexes[lastIndex - 1]?.hasFolderItems && objData?.folderItems) {
      defaultIconColor = 'topic';
    }

    // Set defaults
    if (defaultIconColor) {
      modProperty = {
        ...modProperty,
        icon: this.supData.defaultIcons[defaultIconColor],
        color: this.supData.defaultColors[defaultIconColor],
        type: defaultIconColor.toUpperCase(),
      };
    }

    // Add supplental knownitem
    if (supplementalAddon && objData?.itemId) {
      delete supplementalAddon.itemId;

      modProperty = {
        ...modProperty,
        ...supplementalAddon,
      };
    }

    return modProperty;
  }

  public static getPath(model: any, modelId: string, getProperties?: boolean): any[] | undefined {
    let path;
    let item;

    if (getProperties) {
      item = { ...model as {} };
    } else {
      item = { id: model.modelId || model.itemId, hasFolders: !!model.folders, hasFolderItems: !!model.folderItems, hasDecisionPoints: !!model.decisionPoints, hasOptions: !!model.options };
    }

    if (!model || typeof model !== 'object') return;

    // eslint-disable-next-line consistent-return
    if (model.modelId === modelId || model.itemId === modelId) return [item];

    // eslint-disable-next-line no-return-assign
    (model.folders || model.folderItems || model.decisionPoints || model.options || []).some((child: any) => path = this.getPath(child, modelId, getProperties));

    // eslint-disable-next-line consistent-return
    return path && [item, ...path];
  }

  private static mapSupplemental(baseData: Store): any {
    const mappedData = this.mapObject(baseData as unknown as any[]);

    return mappedData;
  }

  public static initSearch() {
    const searchitems: any[] = [];

    function getArray(objData: any) {
      Object.keys(objData).forEach((key) => {
        if (typeof objData[key] === 'object' && Array.isArray(objData[key])) {
          searchitems.push(objData[key]);

          objData[key].forEach((val: any, i: any) => {
            if (typeof objData[key][i] === 'object' && !Array.isArray(objData[key][i])) {
              getArray(objData[key][i]);
            }
          });
        }
      });
    }
    getArray(this.data);

    this.setSearchItems(searchitems.flat().filter((value: any, index: any, self: any) => self.findIndex((v: any) => v.itemId === value.itemId) === index).filter((i) => i.type));
  }

  public static search(keyword: string): any[] {
    const searchItems = this.getSearchItems();

    // console.log(searchItems?.filter((si) => TextHelper.stripHTML(si?.name)?.toLowerCase()?.includes(keyword.toLowerCase()) || TextHelper.stripHTML(si?.description)?.toLowerCase()?.includes(keyword.toLowerCase()) || TextHelper.stripHTML(si?.tradeoffs)?.toLowerCase()?.includes(keyword.toLowerCase())) || []);
    return searchItems?.filter((si) => TextHelper.stripHTML(si?.name)?.toLowerCase()?.includes(keyword.toLowerCase()) || TextHelper.stripHTML(si?.description)?.toLowerCase()?.includes(keyword.toLowerCase()) || TextHelper.stripHTML(si?.tradeoffs)?.toLowerCase()?.includes(keyword.toLowerCase())) || [];
  }

  public static getPlaylist(type: string): any[] {
    const date = new Date();
    const today = `${date.getUTCMonth() + 1}-${date.getUTCDate()}-${date.getUTCFullYear()}`;

    if (localStorage.getItem(type) && typeof type === 'string' && localStorage.getItem(`date${type}`) === today) {
      const parsed = JSON.parse(localStorage.getItem(type) as string) as any[];

      // if (!parsed[0].color.includes('linear-gradient') || (['goals', 'options'].includes(type) && parsed[0].color === parsed[1].color)) {
      //   parsed = parsed.map((p) => (
      //     { ...p, color: StyleHelper.randomGradient() }
      //   ));

      //   localStorage.setItem(type, JSON.stringify(parsed));
      // }

      return parsed;
    }

    let limit;

    if (type === 'optionoftheday') {
      limit = 1;
    } else if (type === 'options') {
      limit = 5;
    } else {
      limit = 5;
    }

    const inStore = JSON.parse(localStorage.getItem(type) as string) || [];
    const currentIds = inStore.map((i: any) => i.itemId);
    const playlist: any[] = [];
    const list = this.supData.playlists.find((p) => p.type === type)?.items || [];
    const listShuffled = ArrayHelper.shuffle(list);
    const listFiltered = listShuffled.filter((l) => !currentIds.includes(l));

    for (let ctr = 0; ctr !== limit; ctr += 1) {
      const item = listFiltered ? listFiltered[ctr] : '';
      const paths = this.getPath(this.data, item, true) || [];
      const lastItem = paths[paths.length - 1];

      if (lastItem) {
        playlist.push(lastItem);
      }
    }

    localStorage.setItem(`date${type}`, today);
    localStorage.setItem(type, JSON.stringify(playlist));
    return playlist;
  }

  public static getData(): any | null {
    return this.data;
  }

  public static getOptionPhasePath(itemId: string) {
    const optionPath: any[] = DAService.getPath(DAService.getData(), itemId, true) || [];
    const phaseData = optionPath[optionPath.length - (optionPath.length === 6 ? 4 : 3)];

    return phaseData;
  }

  public static getFolders(): Folder[] {
    return this.data.folders;
  }

  public static setSelectedFolder(folder: Folder | null) {
    this.selectedFolder = folder;
  }

  public static getSelectedFolder(): Folder | null {
    return this.selectedFolder;
  }

  public static getSelectedFolderItem(): FolderItem | null {
    return this.selectedFolderItem;
  }

  public static setSelectedFolderItem(folder: FolderItem | null) {
    this.selectedFolderItem = folder;
  }

  public static getSelectedFolderItem2(): FolderItem | null {
    return this.selectedFolderItem2;
  }

  public static setSelectedFolderItem2(folder: FolderItem | null) {
    this.selectedFolderItem2 = folder;
  }

  public static getFolderByItemId(itemId: string): Folder | null {
    this.selectedFolder = this.data.folders.find((i) => i.itemId === itemId) ?? null;
    return this.selectedFolder;
  }

  public static getFolderItemByFolderItemId(folderItemId: string, folderItemItemId: string): FolderItem | null {
    this.selectedFolder = this.getFolderByItemId(folderItemId);
    if (this.selectedFolder) {
      this.selectedFolderItem = this.selectedFolder.folderItems?.find((i) => i.itemId === folderItemItemId) ?? null;
      return this.selectedFolderItem;
    }
    return null;
  }

  public static getFolderItem2ByFolderItemId(folderItem2ItemId: string): FolderItem | null {
    this.selectedFolderItem2 = this.selectedFolderItem?.folderItems.find((i: FolderItem) => i.itemId === folderItem2ItemId) ?? null;
    return this.selectedFolderItem2;
  }

  public static setTitle(title: string) {
    const documentTitle = document.getElementById('header-title');
    if (documentTitle) {
      documentTitle.innerText = title;
    }
  }

  public static setSearchItems(searchItems: any[] | null) {
    this.searchItems = searchItems;
  }

  public static getSearchItems() {
    return this.searchItems;
  }
}
